module.exports = __webpack_public_path__ + "static/media/B3.03c2080a.jpg";